// smapro-insights/src/utils/auth.ts
import { User, UserPermissions, AuthState, StoredAuthData } from '../types/auth';
import { clearAllCaches, signOutFirebase } from '../services/apiService';

export const hasPermission = (user: User | null, permission: keyof UserPermissions): boolean => {
  if (!user?.permissions) return false;
  return Boolean(user.permissions[permission]);
};

// Store auth data to localStorage
export const setStoredAuth = (auth: StoredAuthData): void => {
  // console.log('Storing auth data:', auth);
  // // add stack trace to help debug
  // const stackTrace = new Error().stack;
  // console.log('Stack trace:', stackTrace);
  localStorage.setItem('auth', JSON.stringify(auth));
};

// Get auth data from localStorage
export const getStoredAuth = (): StoredAuthData | null => {
  const authString = localStorage.getItem('auth');
  if (!authString) return null;
  try {
    const authS = JSON.parse(authString) as StoredAuthData;
    console.log('Parsed auth data:', authS);
    return authS;
  } catch (e) {
    console.error('Failed to parse auth from localStorage:', e);
    return null;
  }
};

// Clear auth data from localStorage
export const completeLogout = (): void => {
  localStorage.removeItem('auth');
  sessionStorage.removeItem('auth');
  
  // Also sign out from Firebase
  signOutFirebase().catch(err => {
    console.error('Error signing out from Firebase during logout:', err);
  });
  
  // Clear all in-memory caches when logging out
  clearAllCaches();
};

// Check if the auth token needs validation
export const needsValidation = (auth: StoredAuthData | null): boolean => {
  if (!auth || !auth.token) return true;
  
  // If lastValidated is missing or more than 1 hour old, validate again
  const OneHoursInMs = 1 * 60 * 60 * 1000;
  return !auth.lastValidated || Date.now() - auth.lastValidated > OneHoursInMs;
};

// Get auth headers for API requests
export const getAuthHeaders = (): Record<string, string> => {
  const auth = getStoredAuth();
  return auth?.token ? {
    'Authorization': `Bearer ${auth.token}`,
    'Access-Control-Allow-Headers': 'Authorization',
  } : {};
};